import { createFileRoute } from '@tanstack/react-router';

import { ErrorBoundaryGeneric } from 'components/ErrorBoundaryGeneric/ErrorBoundaryGeneric';

/**
 * Critical-error landing page (`graphqlErrorHandler` hard-redirects here).
 */
export const Route = createFileRoute('/whoops')({
  component: ErrorBoundaryGeneric,
});
